import type { SelectOption } from '@melt-ui/svelte';
import { match } from 'ts-pattern';
import type { EducationLevelEnum } from '$gql/graphql';
import { educationLevelEnumValues } from '$gql/zod-generated';
import type { Choice } from '$components/Form/PrettyChoice.svelte';

export type Value = EducationLevelEnum;
export const values: readonly Value[] = educationLevelEnumValues;

export function valueToLabel(value: Value): string {
    return match(value)
        .with('none', () => 'Sans diplôme')
        .with('bep_cap', () => 'BEP/CAP')
        .with('bac', () => 'Bac')
        .with('bac_plus_1', () => 'Bac + 1')
        .with('bac_plus_2', () => 'Bac + 2')
        .with('bac_plus_3', () => 'Bac + 3')
        .with('bac_plus_4', () => 'Bac + 4')
        .with('bac_plus_5', () => 'Bac + 5 et plus')
        .exhaustive();
}

export const selectOptions: readonly SelectOption<Value>[] = values.map(valueToOption);

export const prettyChoices: readonly Choice<Value>[] = values.map((v) => ({
    value: v,
    key: v,
    label: valueToLabel(v),
}));

export function valueToOption(value: Value): SelectOption<Value> {
    return {
        value,
        label: valueToLabel(value),
    };
}
